import { usePsfSharePageFcm } from 'src/app/pages/psf/share/pageContext';

import type { PsfShareChannel } from '../../types';

export function usePsfOnlyShareChannels(): readonly PsfShareChannel[] {
	const { psfOnlyShareButtonList } = usePsfSharePageFcm();
	return psfOnlyShareButtonList as readonly PsfShareChannel[];
}
